export class BirthDateValidator {
  private regex: RegExp = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/

  validate(value: string): boolean {
    return (value && value !== '-') ? this.regex.test(value) : true
  }

  errorMessage(): string {
    return 'Please use dd-MM-yyyy format".'
  }
}